import { Link } from "react-router-dom";
import { Item } from "../store/viewmodels/ItemViewModel";

export function shuffle(cards: object[]): object[] {
    let shuffableArray = Array.from(cards);

    for (let i: number = 0; i < shuffableArray.length; i++) {
        let card1 = shuffableArray[i];
        let randomIndex = Math.floor(Math.random() * shuffableArray.length);
        let card2 = shuffableArray[randomIndex];

        shuffableArray[i] = card2;
        shuffableArray[randomIndex] = card1;
    }
    return shuffableArray;
}

export function shuffleItems(items: Item[]): Item[] {
    let shuffableArray = Array.from(items);

    for (let i: number = 0; i < shuffableArray.length; i++) {
        let item1 = shuffableArray[i];
        let randomIndex = Math.floor(Math.random() * shuffableArray.length);
        let item2 = shuffableArray[randomIndex];

        shuffableArray[i] = item2;
        shuffableArray[randomIndex] = item1;
    }
    return shuffableArray;
}

export function removeItem(removableItem: Item, items: Item[]): Item[] {
    let itemList: Item[] = Array.from(items);

    for (let i: number = 0; i < itemList.length; i++) {
        if (removableItem.id === itemList[i].id) {
            itemList.splice(i, 1);
        }
    }
    return itemList;
}

export function moveItem(item: Item, items: Item[], itemCount: number) {
    if (items.length >= itemCount) { return items; }

    let itemList: Item[] = Array.from(items);
    let itemIncluded: boolean = false;

    for (let i: number = 0; i < items.length; i++) {
        if (item.id === items[i].id) {
            itemIncluded = true;
            break;
        }
    }
    if (!itemIncluded) { itemList.push(item); }

    return itemList;
}

export function forwardButton(link: string): JSX.Element {
    return (
        <Link to={link}>
            <button className="px-14 py-4 m-5 text-6xl rounded-2xl ring-8 ring-blue-500 hover:bg-blue-400 bg-blue-300 text-blue-600" type="button">
                <span className="ri-arrow-right-s-line"></span>
            </button>
        </Link>
    );
}